import { useContext } from 'react'
import { UserProfileContext, UserProfileContextType } from '../../contexts/UserProfileContext'

export const useUserProfile = (): UserProfileContextType => {
    const userProfile = useContext(UserProfileContext)
    if (!userProfile) {
        throw new Error('useUserProfile must be used within an user profile context')
    }
    return userProfile
}
